import {
  isEqual
} from 'lodash';
import {
  NOT
} from '../../Boolean.lib';
import {
  ID__ATS_TYPE__GH_HARVEST,
  ID__ATS_TYPE__GH_INGESTION
} from '../../Definition';
import Employer from '../../Employer';
import {
  Obj
} from '../../Object.lib';
import {
  updateLoopbackRecord
} from '../BE/loopback.api';

/**
 * Maps the atsContext of an entity from the old format to the new format.
 * The new format is an object with the provider IDs as keys and the provider
 * objects as values.
 *
 * @param {object} options - The options object.
 * @param {string} [options.collection=COLLECTION__EMPLOYERS] - The collection name to update the entity for.
 * @param {object} [options.entity={}] - The entity object to access the atsContext from.
 * @param {number} [options.atsTypeId=ATS_TYPE__NONE_ID] - The ATS type ID to access the property from.
 * @returns {object} The mapped atsContext object.
 * 
 * @example
 * Entity.atsContext = {
 *   [ATS_TYPE__ASHBY_ID]: {
 *     sourceId: 'ashbySourceId',
 *     userId: 'ashbyUserId',
 *     apiKey: 'ashbyApiKey'
 *   },
 *   [ATS_TYPE__LEVER_API_ID]: {
 *     sourceId: 'leverSourceId',
 *     userId: 'leverUserId',
 *     apiKey: 'leverApiKey'
 *   }
 * }
 */
export default function getAtsContextMapped({
  collection = null,
  entity = {},
  atsTypeId = null,
}) {

  // ***Retro-compatibility hacks***
  // Validate the atsContext object
  const atsContext = { ...Obj(entity.atsContext) };
  // Validate greenhouse harvest provider
  const atsApiProviders = { ...Obj(entity.atsApiProviders) };
  if (atsApiProviders[ID__ATS_TYPE__GH_HARVEST]) {
    atsContext[ID__ATS_TYPE__GH_HARVEST] = Obj(
      atsContext[ID__ATS_TYPE__GH_HARVEST] ||
      atsApiProviders[ID__ATS_TYPE__GH_HARVEST]
    );
  }
  // Validate greenhouse ingestion provider
  if (atsApiProviders[ID__ATS_TYPE__GH_INGESTION]) {
    atsContext[ID__ATS_TYPE__GH_INGESTION] = Obj(
      atsContext[ID__ATS_TYPE__GH_INGESTION] ||
      atsApiProviders[ID__ATS_TYPE__GH_INGESTION]
    );
  }
  // Validate current provider
  atsContext[atsTypeId] = { ...Obj(atsContext[atsTypeId]) };
  // Validate manualSubmissionUrl
  atsContext[atsTypeId].manualSubmissionUrl = (
    atsContext[atsTypeId].manualSubmissionUrl ||
    entity.atsUrl
  );
  // Validate jobId
  if (entity.atsJobId) {
    atsContext[atsTypeId].jobId = entity.atsJobId;
  }
  // Remove empty providers
  for (const atsType of Object.keys(atsContext)) {
    if (Object.keys(atsContext[atsType]).length === 0) {
      delete atsContext[atsType];
    }
  }
  // Update the entity if needed
  try {
    if (
      collection &&
      entity.id &&
      NOT(isEqual(atsContext, entity.atsContext))
    ) {
      Employer.cleanCache();
      updateLoopbackRecord({
        collection,
        id: entity.id,
        record: { atsContext }
      });
    }
  }
  catch { }
  // ***End retro-compatibility hacks***

  return atsContext;
}
